import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NbButtonModule, NbCardModule, NbInputModule } from '@nebular/theme';
import { ProductGridModule } from 'app/shared/product-grid/product-grid.module';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { DashboardComponent } from './dashboard.component';


@NgModule({
  imports: [
    CommonModule,
    NbCardModule,
    DropdownModule,
    NbInputModule,
    NbButtonModule,
    ButtonModule,
    RippleModule,
    FormsModule,
    SkeletonModule,
    InputNumberModule,
    CarouselModule,
    CardModule,
    ProductGridModule
  ],
  declarations: [
    DashboardComponent,
  ],
})
export class DashboardModule { }
